import { Widget } from '../widget/widget';

export class HiddenWidget extends Widget {
    async getValue(): Promise<any> {
        return this.$input.value;
    }
}

export class HiddenIntegerWidget extends Widget {
    async getValue(): Promise<any> {
        const { value } = this.$input;

        if (value === '') {
            return null;
        }
        return value;
    }
}
